import React from 'react';
import ProfileSC from './profile.styled';
import InfoBanner from '../../components/info-banner';
import ContentWrap from '../../components/content-wrap';
import ProfileBanner from '../../components/profile-banner';
import ProfileContent from '../../components/profile-content';

const Profile = () => {
  return (
    <ProfileSC>
      <InfoBanner>
        <ProfileBanner />
      </InfoBanner>

      <ContentWrap>
        <ProfileContent />
      </ContentWrap>
    </ProfileSC>
  );
};

export default Profile;
